<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form>
  <div class="label-container" *ngIf="payload.properties.text?.value">
    <label class="flex flex-row">
      <span class="field-label-content">
        <div style="display: inline" [innerHTML]="payload.properties.text?.value | tokenToDiv"></div>
        <span class="required" *ngIf="payload.properties.required.value">*</span>
        <fb-scribe-suggestion-indicator [target]="payload"></fb-scribe-suggestion-indicator>
        <fb-amendment-field-indicator />
      </span>
    </label>
  </div>
  <div class="label-container" *ngIf="payload.properties.content?.value">
    <label class="flex jcc subtitle">
      <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
    </label>
  </div>
  <div class="flex rel">
    <div class="flex responsive" [ngClass]="{ 'multi-column': columns.length > 1 }">
      <div
        class="flex"
        *ngFor="let columnItems of columns; let colIndex = index; trackBy: trackColumn"
        [attr.style]="getStyles()"
      >
        <div
          class="flex flex-nosize control-container"
          *ngFor="let item of columnItems; let colItemIndex = index; trackBy: trackItem"
        >
          <mat-checkbox
            name="cb-{{ colIndex }}-{{ colItemIndex }}"
            class="flex-nosize"
            [(ngModel)]="item.properties.value.value"
            (ngModelChange)="clearScribeSuggestionMarker(payload)"
            [ngModelOptions]="{ standalone: true }"
          >
            <span [innerHTML]="item.properties.text.value | tokenToDiv"></span>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
      This field is required
    </div>
  </div>
</form>
